export const disableForwardingModalCopy = {
  header: '',
  description: '',
  confirmBtnText: '',
  successToast: '',
};
